import useGetOrganization from '@/hooks/queries/organization-api/useGetOrganization';
import usePostPayments from '@/hooks/queries/payments-api/usePostPayments';
import useGetSale from '@/hooks/queries/sales-api/useGetSale';
import usePatchCancelSale from '@/hooks/queries/sales-api/usePatchSale';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import useGetPaymentType from '../queries/payment-type-api/useGetPaymentType';
import { CancelSaleValues } from '@/pages/protected/Sales/SaleDetail/components/cancel-sale-modal/cancel-sale-modal.types';

const useSaleDetail = () => {
  const params = useParams();
  const id = params.id ? params.id : '';
  const { data: sale, isPending: isPendingSale, isError } = useGetSale(id);
  const [addPaymentModal, setAddPaymentModal] = useState(false);
  const [cancelSaleModal, setCancelSaleModal] = useState(false);
  const [addDiscountModal, setAddDiscountModal] = useState(false);
  const { mutate, isPending } = usePostPayments();
  const { data: organization, isPending: isPendingOrganization } =
    useGetOrganization();
  const { data: paymentType, isPending: isPendingPaymentType } =
    useGetPaymentType();
  const { mutate: patchCancelSale, isPending: isPendingPatchCancelSale } =
    usePatchCancelSale();
  const isLoading =
    isPendingSale || isPendingOrganization || isPendingPaymentType;
  const onSubmit = (values: CancelSaleValues) => {
    patchCancelSale(
      {
        saleId: sale?.id ?? '',
        body: values
      },
      { onSuccess: () => setCancelSaleModal(false) }
    );
  };

  return {
    sale,
    organization,
    paymentType,
    onSubmit,
    addPaymentModal,
    setAddPaymentModal,
    addDiscountModal,
    setAddDiscountModal,
    cancelSaleModal,
    setCancelSaleModal,
    isPendingPatchCancelSale,
    mutate,
    isPending,
    isLoading,
    isError
  };
};

export default useSaleDetail;
